import React from 'react';

import i18n from '@yandex-int/i18n';
import block from 'propmods';

import * as keyset from '../../../i18n/AliceSkillForm';
import { InfoIcon } from '../../icons/Info';

import './Note.scss';

const b = block('Note');
const t = i18n(keyset);

type NoteType = 'info' | 'warning';

interface NoteProps {
    type: NoteType;
    hideLabel?: boolean;
    inlineContent?: React.ReactNode;
    children?: React.ReactNode;
}

const labels: Record<NoteType, string> = {
    info: t('attention-header-info'),
    warning: t('attention-header-warning'),
};

const icons: Record<NoteType, JSX.Element> = {
    info: <InfoIcon color="#f0ad4e" type="filled" />,
    warning: <InfoIcon color="#f00" type="filled" />,
};

export const Note: React.FC<NoteProps> = ({ type, children, inlineContent, hideLabel = false }) => {
    return (
        <div {...b({ type })}>
            {!hideLabel && (
                <div {...b('text')}>
                    <strong {...b('label')}>
                        <span {...b('icon')}>{icons[type]}</span>
                        {labels[type]}.{' '}
                    </strong>
                    {inlineContent}
                </div>
            )}
            <div {...b('body')}>{children}</div>
        </div>
    );
};
